const getters = {
	uid: state => state.user.uid,
	token: state => state.user.token,
	info: state => state.user.info,
	id: state => state.user.info.id,
	money: state => state.user.info.money,
	score: state => state.user.info.score,
	isVIP: state => state.user.info.isVIP,
	vipEndTime: state => state.user.info.vipEndTime,
	mobile: state => state.user.info.mobile,
	nickname: state => state.user.info.nickname,
	avatar: state => state.user.info.avatar,
	gender: state => state.user.info.gender,
	birthday: state => state.user.info.birthday,
	qq: state => state.user.info.qq,
	wechat: state => state.user.info.wechat,
	weibo: state => state.user.info.weibo,
	searchHistory: state => state.history.search,
	searchAutoComplete: state => state.history.autoComplete,
	bookId: state => state.book.id,
	bookDetail: state => state.book.detail,
	chapterId: state => state.book.chapterId,
	channels: state => state.category.channels,
	channelId: state => state.category.channelId,
	allCount: state => state.category.allCount,
	classCount: state => state.category.classCount,
	book_name: state => state.system.book_name,
	notes: state => state.system.notes,
	area: state => state.system.area,
	parent_name: state => state.system.parent_name,
	student_name: state => state.system.student_name,
	teacher: state => state.system.teacher,
	mobile: state => state.system.mobile,
	checked: state => state.system.checked
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js